<template>
  <div class="settings-block">
    <div class="place-content-center">
      <div class="icon-container">
        <div class="icon-box apply-loader">
          <slot name="icon"></slot>
        </div>
      </div>
      <div class="text-container">
        <h5 class="settings-block-title apply-loader">
          <slot name="title"></slot>
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SettingsBlock",
};
</script>

<style scoped>
.settings-block {
  width: 100%;
  border-bottom: 1px solid #918dab;
  padding: 10px 10px 14px 10px;
  background-color: #ffffff;
}

.place-content-center {
  display: flex;
  align-items: center;
  gap: 15px;
}

.icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background-color: #1aad62;
  color: #fff;
  width: 41px;
  height: 41px;
  border-radius: 30px;
}

.text-container {
  flex: 1;
  min-width: 0;
  color: #0b0b0b;
  text-align: left;
}

.settings-block-title {
  font-size: 20px;
  font-weight: normal;
  margin: 0;
  padding: 0;
}
</style>
